export const REFERRAL_AMOUNT = 50;
export const REFERRAL_CURRENCY = 'EUR';
